export default {
  'whiteLabel.title': 'White Label',
  'whiteLabel.description':
    'Configure your company brand and custom domain. Changes apply after the runtime refreshes the effective brand.',

  'whiteLabel.sections.effective': 'Effective brand',
  'whiteLabel.sections.branding': 'Local brand',
  'whiteLabel.sections.domain': 'Custom domain',
  'whiteLabel.sections.previews': 'Previews',

  'whiteLabel.effective.source.own': 'Own',
  'whiteLabel.effective.source.inherited': 'Inherited',
  'whiteLabel.effective.defaultBrand': 'AUTOMY',
  'whiteLabel.effective.empty': 'No effective brand could be loaded.',
  'whiteLabel.effective.vsLocalHint':
    'Effective is what users see (own, inherited from channel, or AUTOMY default). Local is what this company edits.',
  'whiteLabel.effective.assets': 'Assets',
  'whiteLabel.effective.automyDefaults': 'AUTOMY product defaults',

  'whiteLabel.form.applyToChildren': 'Apply to children',
  'whiteLabel.form.applyToChildren.hint':
    'When enabled, child companies in the channel may inherit this brand.',
  'whiteLabel.form.isActive.offHint':
    'This company will not show a custom brand and will not inherit from the channel. Runtime will use AUTOMY.',
  'whiteLabel.form.brandName': 'Brand name',
  'whiteLabel.form.mainColor': 'Main color',
  'whiteLabel.form.logo': 'Logo',
  'whiteLabel.form.iconLogo': 'Icon logo',
  'whiteLabel.form.favicon': 'Favicon',
  'whiteLabel.form.font': 'Font (WOFF2)',
  'whiteLabel.form.loginSplash': 'Login splash',
  'whiteLabel.form.supportEmail': 'Support email',
  'whiteLabel.form.supportEmail.hint':
    'Visual contact only. Email sender remains AUTOMY (not SMTP).',
  'whiteLabel.form.contrastSample': 'Aa',
  'whiteLabel.form.assetHint': '{extensions}. Max. {maxSize}. SVG is not allowed.',
  'whiteLabel.form.assetHint.font': '{extensions}. Max. {maxSize}.',
  'whiteLabel.form.assetHint.unavailable':
    'Asset requirements could not be loaded. File upload is unavailable.',

  'whiteLabel.validation.brandNameMax': 'Brand name must be at most 120 characters.',
  'whiteLabel.validation.mainColor': 'Use a hex color like #2255AA.',
  'whiteLabel.validation.supportEmail': 'Enter a valid email address.',
  'whiteLabel.validation.supportEmailMax': 'Support email must be at most 320 characters.',
  'whiteLabel.validation.customDomainRequired': 'Enter a hostname.',
  'whiteLabel.validation.customDomainInvalid':
    'Enter a hostname without protocol, port or path. Domains under automy.global are reserved.',
  'whiteLabel.validation.asset.required': 'Select a file for {slot}.',
  'whiteLabel.validation.asset.noName': 'The {slot} file name is missing.',
  'whiteLabel.validation.asset.empty': 'The {slot} file is empty.',
  'whiteLabel.validation.asset.svg': 'SVG files are not allowed for {slot}. Use {allowed}.',
  'whiteLabel.validation.asset.extension':
    'The extension {extension} is not allowed for {slot}. Use {allowed}.',
  'whiteLabel.validation.asset.mime': 'This file type is not allowed for {slot}. Use {allowed}.',
  'whiteLabel.validation.asset.size': 'The {slot} file exceeds the maximum size of {maxSize}.',
  'whiteLabel.validation.asset.uploadFailed': 'The file could not be uploaded. Try again.',

  'whiteLabel.domain.saveBrandingFirst':
    'Save the local brand first before configuring a custom domain.',
  'whiteLabel.domain.noInheritanceHint':
    'Custom domains are not inherited. Configure them only on the owning company.',
  'whiteLabel.domain.step.register': 'Register',
  'whiteLabel.domain.step.verify': 'Verify DNS',
  'whiteLabel.domain.step.activate': 'Activate',
  'whiteLabel.domain.step.live': 'Live',
  'whiteLabel.domain.status.notConfigured': 'Not configured',
  'whiteLabel.domain.status.pending': 'Pending verification',
  'whiteLabel.domain.status.verified': 'Verified',
  'whiteLabel.domain.status.active': 'Active',
  'whiteLabel.domain.status.disabled': 'Disabled',
  'whiteLabel.domain.field.hostname': 'Custom domain',
  'whiteLabel.domain.field.hostnameHint': 'Hostname only, e.g. brand.acme.com',
  'whiteLabel.domain.field.hostnamePlaceholder': 'brand.example.com',
  'whiteLabel.domain.actions.register': 'Register domain',
  'whiteLabel.domain.actions.verify': 'Verify DNS',
  'whiteLabel.domain.actions.activate': 'Activate domain',
  'whiteLabel.domain.actions.disable': 'Disable domain',
  'whiteLabel.domain.actions.clear': 'Remove domain',
  'whiteLabel.domain.txtOneShotHint':
    'Add this TXT record in your DNS. The verification token is shown only once.',
  'whiteLabel.domain.txtName': 'TXT name',
  'whiteLabel.domain.txtValue': 'TXT value',
  'whiteLabel.domain.txtMissing':
    'The verification token is no longer available. If DNS was not configured, remove the domain and register again.',
  'whiteLabel.domain.verifyPending':
    'DNS has not propagated yet. The domain is still pending verification.',
  'whiteLabel.domain.verifiedHint':
    'DNS matched. You can activate the domain. TLS/CDN readiness is handled outside this screen.',
  'whiteLabel.domain.activeHint': 'This domain is active for serving.',
  'whiteLabel.domain.disabledHint':
    'The domain is disabled and will not be served. Remove it to start over, or contact support if you need to re-activate.',
  'whiteLabel.domain.confirm.disableTitle': 'Disable custom domain?',
  'whiteLabel.domain.confirm.disableContent':
    'The domain will stop being served. Branding configuration is kept.',
  'whiteLabel.domain.confirm.clearTitle': 'Remove custom domain?',
  'whiteLabel.domain.confirm.clearContent':
    'This clears the domain configuration. You will need to register and verify again.',

  'whiteLabel.preview.tab.effective': 'Effective',
  'whiteLabel.preview.tab.local': 'Local',
  'whiteLabel.preview.desktop': 'Desktop',
  'whiteLabel.preview.email': 'Email',
  'whiteLabel.preview.sampleBody': 'Sample content using your brand styles.',
  'whiteLabel.preview.sampleCta': 'Continue',

  'whiteLabel.errors.versionConflict':
    'This configuration changed elsewhere. Local data was reloaded — review and save again.',
  'whiteLabel.errors.loadFailed':
    'The local brand could not be loaded. Saving is disabled until you reload.',
  'whiteLabel.errors.forbidden':
    'You do not have permission to view white label configuration.',
  'whiteLabel.errors.writeForbidden':
    'You do not have permission to change white label configuration.',
};
